module.exports = __webpack_public_path__ + "menu1.jpg?8b2c05a0a708cd45bf59e3a47745b74d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu1.jpg
// module id = 554
// module chunks = 0